import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { CASDispositionType } from '../DispositionTypesContext/types'
import { CIMSPage } from '@cims-online/shared'

export function useExpand(): ExpandOptions<CASDispositionType> {
  return {
    expandable: ({ submittals }) => !!submittals.length,
    render: ({ id, submittals }) => ({
      additionalInfo: [
        {
          type: 'deepLinks',
          label: 'Associated Submittals',
          showMore: { key: id },
          links: submittals.map(
            ({ deleted, packageNumber, packageName, id }) => ({
              page: CIMSPage.CASTracker,
              label: packageNumber,
              tooltip: packageName,
              deep: { recordId: id, deleted },
            })
          ),
        },
      ],
    }),
  }
}
